import React, {useState, useEffect} from 'react'
import { Image, Container } from 'react-bootstrap'
import a3 from "../../../../assets/edgemarketing/a3.png"
import a33 from "../../../../assets/edgemarketing/a33.png"

import '../budgety.css'



function Intro() {

   const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);
  
    useEffect(() => {
      const handleResize = () => {
        setIsSmallScreen(window.innerWidth <= 768);
      };
  
      window.addEventListener('resize', handleResize);
  
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);

    const handleContextMenu = (e) => {
      e.preventDefault(); // Disable right-click
    };


  return (
    <Container 
    fluid 
    className='container-section' 
    style={{
      backgroundColor:"#101010",
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: isSmallScreen ? 'auto' : '100vh'
      }}>
        {isSmallScreen ? (
          <Image src={a33} alt='a33' width={100+"%"} draggable="false" onContextMenu={handleContextMenu}  height="auto" />
        ) : (
          <Image src={a3} alt='a3' width={100+"%"} draggable="false" onContextMenu={handleContextMenu}  height="auto" />
        )}
       
    </Container>
    
     
    
  )
}

export default Intro
